import { fetchUserAnalyticsMonthly } from "./fetchUserAnalyticsMonthly";
import { useUserAnalyticsDateRangeQuery } from "./useUserAnalyticsDateRangeQuery";
import type {
  UserAnalyticsMonthlyQueryParams,
  UserAnalyticsMonthlyResult,
} from "./userAnalyticsMonthlyTypes";

export const USER_ANALYTICS_MONTHLY_QUERY_KEY =
  "USER_ANALYTICS_MONTHLY" as const;

export const useUserAnalyticsMonthly = (
  params: UserAnalyticsMonthlyQueryParams,
) =>
  useUserAnalyticsDateRangeQuery<UserAnalyticsMonthlyResult>(
    USER_ANALYTICS_MONTHLY_QUERY_KEY,
    params,
    () => fetchUserAnalyticsMonthly(params),
  );
